/**
 * Erimish Cart Drawer — Premium Jewelry Cart
 * Standalone module that replaces theme.CartDrawer when the section is present.
 */
(function() {
  'use strict';

  // Guard: only init if our section is present
  if (!document.getElementById('EriCartDrawer')) return;
  var _isCartPage = document.body.classList.contains('template-cart');

  var config = JSON.parse(
    document.getElementById('EriCartDrawerConfig').textContent
  );

  // ============================================================
  // ORIGINAL FETCH REFERENCE
  // The fetch interceptor is installed inline in the section HTML
  // (before defer scripts) so it catches ATC calls even if this
  // file hasn't loaded yet. We use the saved original for our own calls.
  // ============================================================
  var _originalFetch = window._eriOriginalFetch || window.fetch;

  // ============================================================
  // DEBUG LOGGING (tag-gift)
  // Toggle in DevTools console: window.eriGiftDebug = true
  // Or via URL: ?eri_debug=1 (sticks for the session via localStorage)
  // ============================================================
  try {
    var _urlDbg = new URLSearchParams(window.location.search).get('eri_debug');
    if (_urlDbg === '1') localStorage.setItem('eriGiftDebug', '1');
    if (_urlDbg === '0') localStorage.removeItem('eriGiftDebug');
    if (localStorage.getItem('eriGiftDebug') === '1') window.eriGiftDebug = true;
  } catch (e) { /* private mode etc. */ }

  function dbg() {
    if (!window.eriGiftDebug) return;
    var args = ['[EriGift]'].concat(Array.prototype.slice.call(arguments));
    console.log.apply(console, args);
  }

  // ============================================================
  // MONEY FORMATTING
  // ============================================================
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || config.moneyFormat || '${{amount}}';

    function addCommas(n) {
      return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = addCommas((cents / 100.0).toFixed(2));
        break;
      case 'amount_no_decimals':
        value = addCommas(Math.round(cents / 100));
        break;
      case 'amount_with_comma_separator':
        value = (cents / 100.0).toFixed(2).replace('.', ',');
        value = value.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        break;
      default:
        value = addCommas((cents / 100.0).toFixed(2));
    }

    return formatString.replace(placeholderRegex, value);
  }

  // ============================================================
  // MAIN MODULE
  // ============================================================
  var EriCartDrawer = {
    els: {
      drawer: document.getElementById('EriCartDrawer'),
      overlay: document.getElementById('EriCartOverlay'),
      close: document.getElementById('EriCartClose'),
      body: document.getElementById('EriCartBody'),
      items: document.getElementById('EriCartItems'),
      count: document.getElementById('EriCartCount'),
      progressSection: document.getElementById('EriCartProgress'),
      progressMessage: document.getElementById('EriProgressMessage'),
      progressFill: document.getElementById('EriProgressFill'),
      offerBlock: document.getElementById('EriOfferBlock'),
      offerEyebrow: document.getElementById('EriOfferEyebrow'),
      offerHeadline: document.getElementById('EriOfferHeadline'),
      offerSubline: document.getElementById('EriOfferSubline'),
      giftBanner: document.getElementById('EriGiftBanner'),
      giftBannerClaim: document.getElementById('EriGiftBannerClaim'),
      giftBannerTag: document.getElementById('EriGiftBannerTag'),
      giftBannerTagIncentive: document.getElementById('EriGiftBannerTagIncentive'),
      giftBannerTagUnlocked: document.getElementById('EriGiftBannerTagUnlocked'),
      giftModal: document.getElementById('EriGiftModal'),
      giftModalBackdrop: document.getElementById('EriGiftModalBackdrop'),
      giftModalClose: document.getElementById('EriGiftModalClose'),
      giftModalImg: document.getElementById('EriGiftModalImg'),
      giftModalSelect: document.getElementById('EriGiftModalSelect'),
      giftModalAdd: document.getElementById('EriGiftModalAdd'),
      summary: document.getElementById('EriSummary'),
      subtotal: document.getElementById('EriSubtotal'),
      savingsRow: document.getElementById('EriSavingsRow'),
      savingsValue: document.getElementById('EriSavingsValue'),
      discountsRow: document.getElementById('EriDiscountsRow'),
      shippingRow: document.getElementById('EriShippingRow'),
      footer: document.getElementById('EriCartFooter'),
      checkoutBtn: document.getElementById('EriCheckoutBtn'),
      checkoutTotal: document.getElementById('EriCheckoutTotal'),
      trust: document.getElementById('EriTrust'),
      empty: document.getElementById('EriCartEmpty'),
      liveRegion: document.getElementById('EriCartLiveRegion')
    },

    state: {
      isOpen: false,
      cart: null,
      tags: new Set(),
      itemTagManifest: [],
      isUpdating: false,
      _managingGift: false,
      _managingTagGift: false,
      _giftModalDismissed: false,
      _lastOpenTrigger: null,
      _upsellSwiper: null
    },

    // ============================================================
    // INIT
    // ============================================================
    init: function() {
      dbg('init — freeGift:', config.freeGift, ' tagGift:', config.tagGift);
      this.bindEvents();
      this.initOfferBlock();
      this.initUpsellSwiper();

      // Drain any events that fired before this script loaded
      if (window._eriCartQueue && window._eriCartQueue.length > 0) {
        var self = this;
        // Use the last event only (multiple rapid adds → one drawer open)
        setTimeout(function() {
          self.openWithFreshCart(true);
        }, 50);
      }
      // Stop queueing — listeners are now active
      window._eriCartQueue = null;

      // Theme editor support
      if (window.Shopify && Shopify.designMode) {
        var self = this;
        document.addEventListener('shopify:section:select', function(evt) {
          if (evt.detail.sectionId === config.sectionId) self.open();
        });
        document.addEventListener('shopify:section:deselect', function(evt) {
          if (evt.detail.sectionId === config.sectionId) self.close();
        });
      }
    },

    // ============================================================
    // EVENT BINDING
    // ============================================================
    bindEvents: function() {
      var self = this;

      // Close button
      if (this.els.close) {
        this.els.close.addEventListener('click', function() { self.close(); });
      }

      // Overlay click
      if (this.els.overlay) {
        this.els.overlay.addEventListener('click', function() { self.close(); });
      }

      // Escape key
      document.addEventListener('keyup', function(evt) {
        if (evt.key === 'Escape' && self.state.isOpen) self.close();
      });

      // Cart icon clicks — no loading state, just slide open
      document.querySelectorAll('.js-drawer-open-cart').forEach(function(btn) {
        btn.addEventListener('click', function(evt) {
          evt.preventDefault();
          evt.stopPropagation();
          self.openWithFreshCart(false);
        });
      });

      // ATC events — show loading state for instant feedback
      var _addDebounce = null;
      var handleCartAdd = function() {
        if (self.state.isUpdating) return;
        if (_addDebounce) clearTimeout(_addDebounce);
        _addDebounce = setTimeout(function() {
          _addDebounce = null;
          self.openWithFreshCart(true);
        }, 100);
      };

      document.addEventListener('eri:cart:added', handleCartAdd);
      document.addEventListener('ajaxProduct:added', handleCartAdd);
      document.addEventListener('cart:open', function() { self.openWithFreshCart(false); });
      document.addEventListener('cart:close', function() { self.close(); });

      // Gift modal events
      if (this.els.giftModalClose) {
        this.els.giftModalClose.addEventListener('click', function() { self.hideGiftModal(true); });
      }
      if (this.els.giftModalBackdrop) {
        this.els.giftModalBackdrop.addEventListener('click', function() { self.hideGiftModal(true); });
      }
      if (this.els.giftModalSelect) {
        this.els.giftModalSelect.addEventListener('change', function() { self.onGiftVariantChange(); });
      }
      if (this.els.giftModalAdd) {
        this.els.giftModalAdd.addEventListener('click', function() { self.onGiftModalAdd(); });
      }
      if (this.els.giftBannerClaim) {
        this.els.giftBannerClaim.addEventListener('click', function() { self.showGiftModal(); });
      }

      // Event delegation for line item actions
      if (this.els.body) {
        this.els.body.addEventListener('click', function(evt) {
          var actionEl = evt.target.closest('[data-action]');
          if (!actionEl) return;

          var action = actionEl.dataset.action;
          var itemEl = actionEl.closest('[data-key]');

          if (action === 'upsell-add') {
            var variantId = actionEl.dataset.variantId;
            if (variantId) {
              actionEl.textContent = '\u2713 Added';
              actionEl.classList.add('is-added');
              self.addItem(parseInt(variantId), 1);
            }
            return;
          }

          if (!itemEl) return;
          var key = itemEl.dataset.key;
          var currentQty = parseInt(itemEl.dataset.qty || itemEl.querySelector('[data-qty-value]').textContent);

          switch (action) {
            case 'decrease':
              if (currentQty <= 1) {
                self.removeItem(key, itemEl);
              } else {
                self.changeQuantity(key, currentQty - 1);
              }
              break;
            case 'increase':
              if (currentQty < config.maxQty) {
                self.changeQuantity(key, currentQty + 1);
              }
              break;
            case 'remove':
              self.removeItem(key, itemEl);
              break;
          }
        });
      }
    },

    // ============================================================
    // DRAWER OPEN / CLOSE
    // ============================================================
    open: function() {
      if (this.state.isOpen) return;
      this.state.isOpen = true;
      this.els.drawer.classList.add('is-open');
      this.els.overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      this.els.drawer.focus();

      var self = this;
      setTimeout(function() { self.alignMilestoneLabels(); }, 500);
    },

    close: function() {
      if (!this.state.isOpen) return;
      this.state.isOpen = false;
      this.els.drawer.classList.remove('is-open');
      this.els.overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';

      // Return focus to the element that opened the drawer
      if (this.state._lastOpenTrigger) {
        this.state._lastOpenTrigger.focus();
        this.state._lastOpenTrigger = null;
      }
    },

    openWithFreshCart: function(withLoading) {
      var self = this;
      this.state._lastOpenTrigger = document.activeElement;

      if (withLoading) {
        // ATC path: open immediately with loading shimmer (cart won't be empty)
        this.toggleVisibility(false);
        this.showLoading(true);
        this.open();

        this.fetchCart().then(function(cart) {
          self.refreshDrawer(cart);
          self.showLoading(false);
        }).catch(function() {
          self.showLoading(false);
        });
      } else {
        // Cart icon / programmatic: fetch first so we show the correct state
        this.fetchCart().then(function(cart) {
          self.refreshDrawer(cart);
          self.open();
        });
      }
    },

    showLoading: function(isLoading) {
      this.els.drawer.classList.toggle('is-loading', isLoading);
    },

    // ============================================================
    // CART API
    // ============================================================
    fetchCart: function() {
      return _originalFetch(config.routes.cart, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function(r) { return r.json(); });
    },

    fetchCartMarkup: function() {
      return _originalFetch(config.routes.cartPage + '?view=drawer-ajax', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function(r) { return r.text(); });
    },

    changeQuantity: function(key, qty) {
      if (this.state.isUpdating) return Promise.resolve();
      this.state.isUpdating = true;

      var self = this;
      return _originalFetch(config.routes.cartChange, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: key, quantity: qty })
      })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        self.refreshDrawer(cart);
        self.announce(qty === 0 ? 'Item removed from cart.' : 'Cart updated.');
        return cart;
      })
      .catch(function(err) {
        console.error('Cart change failed:', err);
      })
      .finally(function() {
        self.state.isUpdating = false;
      });
    },

    removeItem: function(key, itemEl) {
      // Animate out, then remove
      if (itemEl) {
        itemEl.classList.add('eri-cart__item--removing');
      }
      var self = this;
      setTimeout(function() {
        self.changeQuantity(key, 0);
      }, 300);
    },

    addItem: function(variantId, quantity, properties) {
      if (this.state.isUpdating) return Promise.resolve();
      this.state.isUpdating = true;

      var body = {
        id: variantId,
        quantity: quantity || 1
      };
      if (properties) body.properties = properties;

      var self = this;
      return _originalFetch(config.routes.cartAdd, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(body)
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.status === 422) {
          console.warn('Add to cart failed:', data.description);
          return;
        }
        return self.fetchCart().then(function(cart) {
          self.refreshDrawer(cart);
          self.announce(data.title + ' added to cart.');
        });
      })
      .catch(function(err) {
        console.error('Add to cart failed:', err);
      })
      .finally(function() {
        self.state.isUpdating = false;
      });
    },

    // ============================================================
    // REFRESH DRAWER (orchestrator)
    // ============================================================
    refreshDrawer: function(cart) {
      this.state.cart = cart;

      // Calculate display count excluding hidden gift items
      var displayCount = this.getDisplayItemCount(cart);
      var isEmpty = displayCount === 0;

      // Toggle visibility of sections
      this.toggleVisibility(isEmpty);

      if (isEmpty) {
        this.updateCartBubbles(0);
        this.updateItemCount(0);
        return;
      }

      // Immediate JS updates from cart JSON
      this.updateItemCount(displayCount);
      this.updateSubtotal(cart.total_price);
      this.updateCheckoutTotal(cart.total_price);
      this.updateProgressBar(cart.total_price);
      this.updateFreeGiftBanner(cart.total_price, cart.items);
      this.updateShipping(cart.total_price);
      this.updateCartBubbles(displayCount);

      // Fetch fresh HTML for line items + tags
      var self = this;
      this.fetchCartMarkup().then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        // Replace line items
        var newItems = doc.getElementById('eri-ajax-items');
        if (newItems && self.els.items) {
          self.els.items.innerHTML = newItems.innerHTML;
        }

        // Collect tags for offer engine
        self.state.tags = self.collectTags(doc);
        self.updateOfferBlock(self.state.tags);

        // Collect per-item tag manifest for tag-based free gift
        self.state.itemTagManifest = self.collectItemTagManifest(doc);
        self.updateTagGiftBanner(self.state.itemTagManifest);
        self.manageTagGift(cart, self.state.itemTagManifest);

        // Update savings from server calculation
        var dataEl = doc.getElementById('eri-ajax-data');
        if (dataEl) {
          var savings = parseInt(dataEl.dataset.savings || '0');
          self.updateSavings(savings);
        }

        // Update discounts
        var discountsEl = doc.getElementById('eri-ajax-discounts');
        if (discountsEl && self.els.discountsRow) {
          var discountSpans = discountsEl.querySelectorAll('[data-discount-title]');
          var discountHtml = '';
          discountSpans.forEach(function(span) {
            discountHtml += '<div class="eri-summary__row eri-summary__row--discounts">' +
              '<span>' + span.dataset.discountTitle + '</span>' +
              '<span>-' + formatMoney(parseInt(span.dataset.discountAmount)) + '</span>' +
              '</div>';
          });
          self.els.discountsRow.innerHTML = discountHtml;
        }

        // Update upsells
        self.updateUpsells(cart.items);

        // Manage free gift product
        self.manageFreeGift(cart);

        // Align progress bar labels
        self.alignMilestoneLabels();

        // Dispatch theme-compatible event
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { cart: cart }
        }));
      });
    },

    // ============================================================
    // UI UPDATE METHODS
    // ============================================================
    getDisplayItemCount: function(cart) {
      var count = 0;
      var giftProductId = config.freeGift ? config.freeGift.productId : null;
      var tagGiftProductId = config.tagGift ? config.tagGift.productId : null;
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        var isGift = (giftProductId && item.product_id === giftProductId) ||
                     (tagGiftProductId && item.product_id === tagGiftProductId) ||
                     (item.properties && item.properties._gift === 'true');
        if (!isGift) {
          count += item.quantity;
        }
      }
      return count;
    },

    toggleVisibility: function(isEmpty) {
      var display = isEmpty ? 'none' : '';
      var emptyDisplay = isEmpty ? '' : 'none';

      if (this.els.body) this.els.body.style.display = display;
      if (this.els.progressSection) this.els.progressSection.style.display = display;
      if (this.els.summary) this.els.summary.style.display = display;
      if (this.els.footer) this.els.footer.style.display = display;
      if (this.els.trust) this.els.trust.style.display = display;

      if (this.els.empty) {
        this.els.empty.classList.toggle('is-visible', isEmpty);
      }
    },

    updateItemCount: function(count) {
      if (this.els.count) {
        this.els.count.textContent = '(' + count + ' ' + (count === 1 ? 'item' : 'items') + ')';
      }
    },

    updateSubtotal: function(totalPrice) {
      if (this.els.subtotal) {
        this.els.subtotal.textContent = formatMoney(totalPrice);
      }
    },

    updateCheckoutTotal: function(totalPrice) {
      if (this.els.checkoutTotal) {
        this.els.checkoutTotal.textContent = formatMoney(totalPrice);
      }
    },

    updateSavings: function(savingsCents) {
      if (!this.els.savingsRow || !this.els.savingsValue) return;
      if (savingsCents > 0) {
        this.els.savingsRow.style.display = 'flex';
        this.els.savingsValue.textContent = '-' + formatMoney(savingsCents);
      } else {
        this.els.savingsRow.style.display = 'none';
      }
    },

    updateShipping: function(totalPrice) {
      if (!this.els.shippingRow) return;
      var tier2 = config.tiers.length > 1 ? config.tiers[1].threshold : 0;
      if (tier2 > 0 && totalPrice >= tier2) {
        this.els.shippingRow.classList.add('is-free');
        this.els.shippingRow.style.display = '';
        this.els.shippingRow.innerHTML = '&#10003; ' + config.summaryLabels.shippingFree;
      } else {
        this.els.shippingRow.classList.remove('is-free');
        this.els.shippingRow.style.display = 'none';
        this.els.shippingRow.innerHTML = '';
      }
    },

    updateCartBubbles: function(count) {
      document.querySelectorAll('.cart-link__bubble').forEach(function(bubble) {
        bubble.classList.toggle('cart-link__bubble--visible', count > 0);
      });
      document.querySelectorAll('.cart-link__bubble-num').forEach(function(num) {
        num.textContent = count;
      });
    },

    // ============================================================
    // PROGRESS BAR
    // ============================================================
    updateProgressBar: function(totalPrice) {
      if (!this.els.progressFill || !config.tiers.length) return;

      var maxThreshold = config.tiers[config.tiers.length - 1].threshold;
      if (maxThreshold === 0) return;

      // Fill by segment, not proportionally — each tier occupies an equal portion of the bar
      var numTiers = config.tiers.length;
      var segmentWidth = 100 / numTiers; // e.g., 2 tiers = 50% each
      var pct = 0;

      for (var t = 0; t < numTiers; t++) {
        var segStart = t === 0 ? 0 : config.tiers[t - 1].threshold;
        var segEnd = config.tiers[t].threshold;
        if (totalPrice >= segEnd) {
          // Fully past this tier
          pct += segmentWidth;
        } else if (totalPrice > segStart) {
          // Partially through this segment
          var segRange = segEnd - segStart;
          if (segRange > 0) {
            pct += segmentWidth * ((totalPrice - segStart) / segRange);
          }
          break;
        } else {
          break;
        }
      }
      pct = Math.min(pct, 100);
      this.els.progressFill.style.width = pct + '%';

      // Shimmer animation
      this.els.progressFill.classList.add('is-animating');
      var fill = this.els.progressFill;
      setTimeout(function() { fill.classList.remove('is-animating'); }, 1500);

      // Milestone states
      var m0 = document.getElementById('EriMilestone0');
      var l0 = document.getElementById('EriMilestoneLabel0');
      if (m0) m0.classList.add('is-unlocked');
      if (l0) l0.classList.add('is-unlocked');

      for (var i = 0; i < config.tiers.length; i++) {
        var mi = document.getElementById('EriMilestone' + (i + 1));
        var li = document.getElementById('EriMilestoneLabel' + (i + 1));
        if (mi) mi.classList.toggle('is-unlocked', totalPrice >= config.tiers[i].threshold);
        if (li) li.classList.toggle('is-unlocked', totalPrice >= config.tiers[i].threshold);
      }

      // Message
      if (this.els.progressMessage) {
        var tiersSame = config.tiers.length === 2 &&
          config.tiers[0].threshold === config.tiers[1].threshold;

        if (totalPrice >= maxThreshold) {
          this.els.progressMessage.innerHTML = '&#10003; You\'ve unlocked <strong>all rewards!</strong>';
        } else if (tiersSame && totalPrice < config.tiers[0].threshold) {
          var remaining = formatMoney(config.tiers[0].threshold - totalPrice);
          this.els.progressMessage.innerHTML = 'You\'re <strong>' + remaining + '</strong> away from ' +
            config.tiers[0].rewardMessage + ' &amp; ' + config.tiers[1].rewardMessage + '!';
        } else {
          var nextTier = null;
          for (var j = 0; j < config.tiers.length; j++) {
            if (totalPrice < config.tiers[j].threshold) {
              nextTier = config.tiers[j];
              break;
            }
          }
          if (nextTier) {
            var remaining = formatMoney(nextTier.threshold - totalPrice);
            this.els.progressMessage.innerHTML = 'You\'re <strong>' + remaining + '</strong> away from ' + nextTier.rewardMessage + '!';
          }
        }
      }
    },

    alignMilestoneLabels: function() {
      var container = document.querySelector('.eri-cart__milestone-labels');
      if (!container) return;
      var containerRect = container.getBoundingClientRect();
      if (containerRect.width === 0) return;

      var milestones = document.querySelectorAll('.eri-cart__milestone');
      var labels = document.querySelectorAll('.eri-cart__milestone-label-group');
      var drawer = this.els.drawer;
      var drawerRight = drawer.getBoundingClientRect().right;

      milestones.forEach(function(m, i) {
        var label = labels[i];
        if (!label) return;

        var icon = m.querySelector('.eri-cart__milestone-icon');
        var anchor = icon && icon.offsetWidth > 0 ? icon : m;
        var anchorRect = anchor.getBoundingClientRect();
        var anchorCx = anchorRect.left + anchorRect.width / 2;

        var labelW = label.offsetWidth;
        var idealLeft = anchorCx - containerRect.left - labelW / 2;

        var maxLeft = drawerRight - containerRect.left - labelW - 8;
        idealLeft = Math.max(0, Math.min(idealLeft, maxLeft));

        label.style.left = idealLeft + 'px';
        label.style.transform = 'none';
      });
    },

    // ============================================================
    // OFFER ENGINE
    // ============================================================
    initOfferBlock: function() {
      // Set initial offer from server-rendered tags
      var tags = new Set();
      var tagEls = document.querySelectorAll('#eri-ajax-tags [data-tag]');
      if (tagEls.length === 0) {
        // On initial page load, tags may be in the section's line items context
        // Collect from any pre-rendered cart items
        // Fall through to use whatever first rule matches or fallback
      }
      tagEls.forEach(function(el) { tags.add(el.dataset.tag); });
      this.state.tags = tags;
      this.updateOfferBlock(tags);
    },

    collectTags: function(doc) {
      var tags = new Set();
      var tagEls = doc.querySelectorAll('#eri-ajax-tags [data-tag]');
      tagEls.forEach(function(el) { tags.add(el.dataset.tag); });
      return tags;
    },

    collectItemTagManifest: function(doc) {
      var manifest = [];
      var nodes = doc.querySelectorAll('#eri-ajax-item-tags [data-product-id]');
      if (!nodes.length) {
        dbg('manifest: NO <#eri-ajax-item-tags> nodes in AJAX response — drawer-ajax template may not be deployed yet, or cart is empty');
      }
      nodes.forEach(function(el) {
        var tagsRaw = el.dataset.tags || '';
        var tags = tagsRaw.length ? tagsRaw.split(',') : [];
        manifest.push({
          productId: parseInt(el.dataset.productId, 10),
          quantity: parseInt(el.dataset.quantity, 10) || 0,
          isGift: el.dataset.isGift === '1',
          tags: tags
        });
      });
      dbg('manifest:', manifest);
      return manifest;
    },

    evaluateOfferRules: function(tags) {
      var rules = document.querySelectorAll('#EriCartOfferRules .eri-offer-rule');
      for (var i = 0; i < rules.length; i++) {
        var ruleTag = rules[i].dataset.tag;
        if (!ruleTag || ruleTag === '' || tags.has(ruleTag)) {
          return {
            eyebrow: rules[i].dataset.eyebrow,
            headline: rules[i].dataset.headline,
            subline: rules[i].dataset.subline,
            bgColor: rules[i].dataset.bg,
            textColor: rules[i].dataset.textColor
          };
        }
      }
      return null;
    },

    updateOfferBlock: function(tags) {
      if (!this.els.offerBlock) return;

      var offer = this.evaluateOfferRules(tags);
      if (!offer) {
        this.els.offerBlock.style.display = 'none';
        return;
      }

      var currentHeadline = this.els.offerHeadline ? this.els.offerHeadline.textContent : '';
      if (currentHeadline === offer.headline) {
        this.els.offerBlock.style.display = '';
        return;
      }

      this.els.offerBlock.style.display = '';
      var self = this;
      this.els.offerBlock.style.opacity = '0';
      setTimeout(function() {
        if (self.els.offerEyebrow) self.els.offerEyebrow.textContent = offer.eyebrow;
        if (self.els.offerHeadline) self.els.offerHeadline.textContent = offer.headline;
        if (self.els.offerSubline) self.els.offerSubline.textContent = offer.subline;
        if (offer.bgColor) {
          self.els.offerBlock.style.background = 'linear-gradient(135deg, ' + offer.bgColor + ', ' + offer.bgColor + ')';
        }
        self.els.offerBlock.style.opacity = '1';
      }, 250);
    },

    // ============================================================
    // FREE GIFT MANAGEMENT
    // ============================================================
    updateFreeGiftBanner: function(totalPrice, items) {
      if (!this.els.giftBanner || !config.freeGift) return;
      var threshold = config.freeGift.threshold;
      if (!threshold) return;

      // Exclude gift item from total when checking threshold
      var giftProductId = config.freeGift.productId;
      var adjustedTotal = totalPrice;
      if (giftProductId && items) {
        for (var i = 0; i < items.length; i++) {
          if (items[i].product_id === giftProductId) {
            adjustedTotal -= items[i].final_line_price;
            break;
          }
        }
      }

      var isUnlocked = adjustedTotal >= threshold;
      this.els.giftBanner.classList.toggle('is-visible', isUnlocked);

      // Show claim button if gift is unlocked but user dismissed the modal and gift not yet in cart
      if (this.els.giftBannerClaim && config.freeGift.hasMultipleVariants) {
        var giftInCart = false;
        if (items && giftProductId) {
          for (var j = 0; j < items.length; j++) {
            if (items[j].product_id === giftProductId) {
              giftInCart = true;
              break;
            }
          }
        }
        this.els.giftBannerClaim.style.display =
          (isUnlocked && this.state._giftModalDismissed && !giftInCart) ? '' : 'none';
      }
    },

    manageFreeGift: function(cart) {
      if (this.state._managingGift) return;
      if (!config.freeGift || !config.freeGift.variantId || !config.freeGift.threshold) return;

      var giftThreshold = config.freeGift.threshold;
      var giftVariantId = config.freeGift.variantId;
      var giftProductId = config.freeGift.productId;

      var giftInCart = null;
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        if (item.variant_id === giftVariantId ||
            item.product_id === giftProductId) {
          giftInCart = item;
          break;
        }
      }

      // Exclude gift from threshold check
      var cartTotal = cart.total_price;
      if (giftInCart) {
        cartTotal -= giftInCart.final_line_price;
      }

      var self = this;
      if (cartTotal >= giftThreshold && !giftInCart) {
        // Multi-variant: show picker modal. Single variant: auto-add.
        if (config.freeGift.hasMultipleVariants && !this.state._giftModalDismissed) {
          this.showGiftModal();
        } else if (!config.freeGift.hasMultipleVariants) {
          this.state._managingGift = true;
          this.addItem(giftVariantId, 1, { _gift: 'true' }).then(function() {
            self.state._managingGift = false;
          }).catch(function() {
            self.state._managingGift = false;
          });
        }
        // If dismissed, do nothing — banner "Choose Your Gift" button is visible
      } else if (cartTotal < giftThreshold && giftInCart) {
        // Remove gift and reset modal state so it can show again next time
        this.state._managingGift = true;
        this.state._giftModalDismissed = false;
        this.changeQuantity(giftInCart.key, 0).then(function() {
          self.state._managingGift = false;
        }).catch(function() {
          self.state._managingGift = false;
        });
      }
    },

    // ============================================================
    // TAG-BASED FREE GIFT
    // ============================================================
    countTagMatchedQty: function(manifest) {
      if (!config.tagGift) { dbg('count: config.tagGift missing'); return 0; }
      if (!config.tagGift.tags || !config.tagGift.tags.length) {
        dbg('count: no tags configured', config.tagGift);
        return 0;
      }
      if (!manifest || !manifest.length) { dbg('count: empty manifest'); return 0; }
      var needles = config.tagGift.tags;
      var tagGiftProductId = config.tagGift.productId;
      var qty = 0;
      var perItem = [];
      for (var i = 0; i < manifest.length; i++) {
        var row = manifest[i];
        if (row.isGift) { perItem.push({ id: row.productId, skipped: 'isGift' }); continue; }
        if (tagGiftProductId && row.productId === tagGiftProductId) {
          perItem.push({ id: row.productId, skipped: 'is the tag-gift product' });
          continue;
        }
        var matched = false;
        var matchedNeedle = null;
        for (var j = 0; j < row.tags.length && !matched; j++) {
          var t = row.tags[j];
          for (var k = 0; k < needles.length; k++) {
            if (t === needles[k]) { matched = true; matchedNeedle = t; break; }
          }
        }
        if (matched) qty += row.quantity;
        perItem.push({
          id: row.productId,
          qty: row.quantity,
          tags: row.tags,
          matched: matched,
          matchedTag: matchedNeedle
        });
      }
      dbg('count breakdown:', { needles: needles, perItem: perItem, totalQty: qty });
      return qty;
    },

    renderTagGiftIncentive: function(remaining) {
      if (!this.els.giftBannerTagIncentive || !config.tagGift) return;
      var tmpl = config.tagGift.incentiveMessage || '';
      var msg = tmpl
        .replace(/\{\s*remaining\s*\}/g, String(remaining))
        .replace(/\{\s*encouraged\s*\}/g, config.tagGift.encouragedLabel || '')
        .replace(/\{\s*gift\s*\}/g, config.tagGift.giftTitle || '');
      this.els.giftBannerTagIncentive.textContent = msg;
    },

    updateTagGiftBanner: function(manifest) {
      if (!this.els.giftBannerTag) { dbg('banner: #EriGiftBannerTag element missing (tag-gift not configured in schema?)'); return; }
      if (!config.tagGift) { dbg('banner: config.tagGift missing'); return; }
      var threshold = config.tagGift.threshold;
      if (!threshold) { dbg('banner: threshold is 0/null', config.tagGift); return; }
      var matchedQty = this.countTagMatchedQty(manifest);
      var isUnlocked = matchedQty >= threshold;
      var showIncentive = matchedQty > 0 && !isUnlocked;
      var bannerVisible = isUnlocked || showIncentive;
      var remaining = Math.max(0, threshold - matchedQty);
      dbg('banner update:', {
        matchedQty: matchedQty, threshold: threshold, remaining: remaining,
        isUnlocked: isUnlocked, showIncentive: showIncentive
      });
      this.els.giftBannerTag.classList.toggle('is-visible', bannerVisible);
      this.els.giftBannerTag.classList.toggle('is-incentive', showIncentive);
      this.els.giftBannerTag.classList.toggle('is-unlocked', isUnlocked);
      if (this.els.giftBannerTagIncentive) {
        this.els.giftBannerTagIncentive.style.display = showIncentive ? '' : 'none';
      }
      if (this.els.giftBannerTagUnlocked) {
        this.els.giftBannerTagUnlocked.style.display = isUnlocked ? '' : 'none';
      }
      if (showIncentive) this.renderTagGiftIncentive(remaining);
    },

    manageTagGift: function(cart, manifest) {
      if (this.state._managingTagGift) { dbg('manage: already in-flight, skipping'); return; }
      if (!config.tagGift) { dbg('manage: config.tagGift missing'); return; }
      if (!config.tagGift.variantId) { dbg('manage: tagGift.variantId missing (gift product not picked in block settings)'); return; }
      if (!config.tagGift.threshold) { dbg('manage: tagGift.threshold is 0'); return; }

      var threshold = config.tagGift.threshold;
      var giftVariantId = config.tagGift.variantId;
      var giftProductId = config.tagGift.productId;

      var giftInCart = null;
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        if (item.product_id === giftProductId &&
            item.properties && item.properties._gift === 'true') {
          giftInCart = item;
          break;
        }
      }

      var matchedQty = this.countTagMatchedQty(manifest);
      var self = this;
      dbg('manage decision:', {
        matchedQty: matchedQty,
        threshold: threshold,
        giftInCart: giftInCart ? { key: giftInCart.key, productId: giftInCart.product_id } : null,
        giftVariantId: giftVariantId,
        giftProductId: giftProductId
      });

      if (matchedQty >= threshold && !giftInCart) {
        dbg('manage: ADDING tag-gift, variantId=' + giftVariantId);
        this.state._managingTagGift = true;
        this.addItem(giftVariantId, 1, { _gift: 'true' }).then(function(res) {
          dbg('manage: ADD success', res);
          self.state._managingTagGift = false;
        }).catch(function(err) {
          dbg('manage: ADD FAILED', err);
          self.state._managingTagGift = false;
        });
      } else if (matchedQty < threshold && giftInCart) {
        dbg('manage: REMOVING tag-gift, key=' + giftInCart.key);
        this.state._managingTagGift = true;
        this.changeQuantity(giftInCart.key, 0).then(function() {
          dbg('manage: REMOVE success');
          self.state._managingTagGift = false;
        }).catch(function(err) {
          dbg('manage: REMOVE FAILED', err);
          self.state._managingTagGift = false;
        });
      } else {
        dbg('manage: no-op (threshold not crossed OR gift already in expected state)');
      }
    },

    // Manual inspection helper — call from DevTools: EriCartDrawer.debugTagGift()
    debugTagGift: function() {
      console.log('[EriGift] === DEBUG SNAPSHOT ===');
      console.log('[EriGift] config.tagGift:', config.tagGift);
      console.log('[EriGift] config.freeGift:', config.freeGift);
      console.log('[EriGift] giftBannerTag element:', this.els.giftBannerTag);
      console.log('[EriGift] current manifest:', this.state.itemTagManifest);
      console.log('[EriGift] current cart:', this.state.cart);
      if (config.tagGift) {
        console.log('[EriGift] matched qty NOW:', this.countTagMatchedQty(this.state.itemTagManifest));
      }
    },

    // ============================================================
    // GIFT VARIANT MODAL
    // ============================================================
    showGiftModal: function() {
      if (!this.els.giftModal) return;
      this.els.giftModal.classList.add('is-open');
      this.els.giftModal.setAttribute('aria-hidden', 'false');

      // Hide the claim button while modal is open
      if (this.els.giftBannerClaim) {
        this.els.giftBannerClaim.style.display = 'none';
      }
    },

    hideGiftModal: function(wasDismissed) {
      if (!this.els.giftModal) return;
      this.els.giftModal.classList.remove('is-open');
      this.els.giftModal.setAttribute('aria-hidden', 'true');

      if (wasDismissed) {
        this.state._giftModalDismissed = true;
        // Show "Choose Your Gift" button on the banner
        if (this.els.giftBannerClaim) {
          this.els.giftBannerClaim.style.display = '';
        }
      }
    },

    onGiftVariantChange: function() {
      if (!this.els.giftModalSelect || !this.els.giftModalImg) return;
      var selected = this.els.giftModalSelect.options[this.els.giftModalSelect.selectedIndex];
      var imageUrl = selected.dataset.image;
      if (imageUrl) {
        this.els.giftModalImg.style.opacity = '0';
        var img = this.els.giftModalImg;
        setTimeout(function() {
          img.src = imageUrl;
          img.style.opacity = '1';
        }, 200);
      }
    },

    onGiftModalAdd: function() {
      if (!this.els.giftModalSelect) return;
      var variantId = parseInt(this.els.giftModalSelect.value);
      if (!variantId) return;

      var self = this;
      var btn = this.els.giftModalAdd;
      btn.classList.add('is-loading');
      btn.textContent = 'Adding...';

      this.state._managingGift = true;
      this.addItem(variantId, 1, { _gift: 'true' }).then(function() {
        self.state._managingGift = false;
        self.hideGiftModal(false);
        btn.classList.remove('is-loading');
        btn.textContent = 'Add to Bag';
      }).catch(function() {
        self.state._managingGift = false;
        btn.classList.remove('is-loading');
        btn.textContent = 'Add to Bag';
      });
    },

    // ============================================================
    // UPSELLS
    // ============================================================
    initUpsellSwiper: function() {
      var swiperEl = document.getElementById('EriUpsellSwiper');
      if (!swiperEl || typeof Swiper === 'undefined') return;

      this.state._upsellSwiper = new Swiper(swiperEl, {
        slidesPerView: 2.4,
        spaceBetween: 12,
        watchOverflow: true,
        navigation: {
          prevEl: '#EriUpsellPrev',
          nextEl: '#EriUpsellNext'
        },
        breakpoints: {
          0: { slidesPerView: 2.3 },
          400: { slidesPerView: 2.4 }
        }
      });
    },

    refreshUpsellSwiper: function() {
      if (this.state._upsellSwiper) {
        this.state._upsellSwiper.update();
        this.state._upsellSwiper.slideTo(0, 0);
      } else {
        this.initUpsellSwiper();
      }
    },

    updateUpsells: function(cartItems) {
      var cartProductIds = cartItems.map(function(item) { return item.product_id; });

      // If using recommendations API (or no collection set), fetch fresh recommendations
      if (config.upsell && (config.upsell.useRecommendations || !config.upsell.hasCollection)) {
        if (cartItems.length > 0) {
          this.fetchRecommendations(cartItems, cartProductIds);
        }
        return;
      }

      // Collection-based: just hide cards that are now in the cart
      var self = this;
      document.querySelectorAll('.eri-upsell__card').forEach(function(card) {
        var productId = parseInt(card.dataset.productId);
        card.classList.toggle('eri-upsell__card--hidden', cartProductIds.indexOf(productId) !== -1);
      });
      this.refreshUpsellSwiper();
    },

    fetchRecommendations: function(cartItems, cartProductIds) {
      var carousel = document.getElementById('EriUpsellCarousel');
      if (!carousel) return;

      // Use the first non-gift item as the seed
      var seedItem = null;
      for (var i = 0; i < cartItems.length; i++) {
        if (!cartItems[i].properties || cartItems[i].properties._gift !== 'true') {
          seedItem = cartItems[i];
          break;
        }
      }
      if (!seedItem) return;

      var maxCount = (config.upsell && config.upsell.count) || 4;
      var url = '/recommendations/products.json?product_id=' + seedItem.product_id +
                '&limit=' + (maxCount + cartProductIds.length) + '&intent=related';

      var self = this;
      _originalFetch(url)
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (!data.products || data.products.length === 0) return;

          var html = '';
          var rendered = 0;

          for (var i = 0; i < data.products.length && rendered < maxCount; i++) {
            var p = data.products[i];
            // Skip products already in cart
            if (cartProductIds.indexOf(p.id) !== -1) continue;
            // Skip unavailable products
            if (!p.available) continue;

            var variant = p.variants && p.variants[0] ? p.variants[0] : null;
            var variantId = variant ? variant.id : '';
            var price = variant ? variant.price : p.price;
            var comparePrice = variant && variant.compare_at_price > variant.price ? variant.compare_at_price : 0;
            var imageUrl = p.featured_image ? p.featured_image : '';

            var priceHtml = '';
            if (comparePrice > 0) {
              priceHtml = '<span class="eri-cart__price-compare">' + formatMoney(comparePrice) + '</span> ' + formatMoney(price);
            } else {
              priceHtml = formatMoney(price);
            }

            html += '<div class="swiper-slide eri-upsell__card" data-product-id="' + p.id + '" data-variant-id="' + variantId + '">' +
              '<div class="eri-upsell__card-image">' +
                (imageUrl ? '<img src="' + imageUrl + '&width=260" alt="' + self.escapeHtml(p.title) + '" loading="lazy">' : '') +
              '</div>' +
              '<div class="eri-upsell__card-name">' + self.escapeHtml(p.title) + '</div>' +
              '<div class="eri-upsell__card-price">' + priceHtml + '</div>' +
              '<button type="button" class="eri-upsell__add-btn" data-action="upsell-add" data-variant-id="' + variantId + '" aria-label="Add ' + self.escapeHtml(p.title) + ' to cart">+ Add</button>' +
            '</div>';

            rendered++;
          }

          carousel.innerHTML = html;
          self.refreshUpsellSwiper();
        })
        .catch(function(err) {
          console.warn('Recommendations fetch failed:', err);
        });
    },

    escapeHtml: function(str) {
      var div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    },

    // ============================================================
    // ACCESSIBILITY
    // ============================================================
    announce: function(message) {
      if (this.els.liveRegion) {
        this.els.liveRegion.textContent = message;
        var region = this.els.liveRegion;
        setTimeout(function() { region.textContent = ''; }, 3000);
      }
    }
  };

  // ============================================================
  // INITIALIZE
  // ============================================================
  window.EriCartDrawer = EriCartDrawer;

  if (!_isCartPage) {
    EriCartDrawer.init();
  } else {
    // /cart page: skip the drawer UI, only enforce gift consistency
    initCartPageGiftEnforcer();
  }

  // ============================================================
  // CART PAGE GIFT ENFORCER
  // Runs on /cart only. Verifies that any free-gift line in the cart
  // still meets its trigger condition (price or tag), and removes it
  // if not. Triggers on load + after every cart-modifying fetch.
  // ============================================================
  function initCartPageGiftEnforcer() {
    var enforcing = false;

    function runOnce() {
      if (enforcing) return Promise.resolve();
      enforcing = true;
      return Promise.all([
        _originalFetch('/cart.js').then(function(r) { return r.json(); }),
        _originalFetch('/cart?view=drawer-ajax', {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        }).then(function(r) { return r.text(); })
      ]).then(function(results) {
        var cart = results[0];
        var doc = new DOMParser().parseFromString(results[1], 'text/html');
        var manifest = EriCartDrawer.collectItemTagManifest(doc);
        var toRemove = [];
        var toAdd = [];

        // ---- Price-based gift enforcement ----
        if (config.freeGift && config.freeGift.variantId && config.freeGift.threshold) {
          var pGiftProductId = config.freeGift.productId;
          var pGiftLine = null;
          var adjustedTotal = cart.total_price;
          for (var i = 0; i < cart.items.length; i++) {
            if (cart.items[i].product_id === pGiftProductId) {
              pGiftLine = cart.items[i];
              adjustedTotal -= pGiftLine.final_line_price;
              break;
            }
          }
          var pQualifies = adjustedTotal >= config.freeGift.threshold;
          if (pGiftLine && !pQualifies) {
            toRemove.push(pGiftLine.key);
            dbg('cart-page: price-gift no longer qualifies, will remove', {
              cartTotal: adjustedTotal, threshold: config.freeGift.threshold
            });
          } else if (!pGiftLine && pQualifies) {
            // Skip multi-variant gifts: drawer handles those via picker modal.
            if (!config.freeGift.hasMultipleVariants) {
              toAdd.push({
                id: config.freeGift.variantId,
                quantity: 1,
                properties: { _gift: 'true' }
              });
              dbg('cart-page: price-gift threshold met, will add', {
                cartTotal: adjustedTotal, threshold: config.freeGift.threshold
              });
            } else {
              dbg('cart-page: price-gift threshold met but has multiple variants — skipping (drawer modal owns this)');
            }
          }
        }

        // ---- Tag-based gift enforcement ----
        if (config.tagGift && config.tagGift.variantId && config.tagGift.threshold) {
          var tGiftProductId = config.tagGift.productId;
          var tGiftLine = null;
          for (var j = 0; j < cart.items.length; j++) {
            var it = cart.items[j];
            if (it.product_id === tGiftProductId &&
                it.properties && it.properties._gift === 'true') {
              tGiftLine = it;
              break;
            }
          }
          var matchedQty = EriCartDrawer.countTagMatchedQty(manifest);
          var tQualifies = matchedQty >= config.tagGift.threshold;
          if (tGiftLine && !tQualifies) {
            toRemove.push(tGiftLine.key);
            dbg('cart-page: tag-gift no longer qualifies, will remove', {
              matchedQty: matchedQty, threshold: config.tagGift.threshold
            });
          } else if (!tGiftLine && tQualifies) {
            toAdd.push({
              id: config.tagGift.variantId,
              quantity: 1,
              properties: { _gift: 'true' }
            });
            dbg('cart-page: tag-gift threshold met, will add', {
              matchedQty: matchedQty, threshold: config.tagGift.threshold
            });
          }
        }

        if (toRemove.length === 0 && toAdd.length === 0) {
          dbg('cart-page: cart already consistent with gift rules');
          enforcing = false;
          return;
        }

        // Apply removals first, then additions; then reload so the page UI matches.
        var chain = Promise.resolve();
        toRemove.forEach(function(key) {
          chain = chain.then(function() {
            return _originalFetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({ id: key, quantity: 0 })
            });
          });
        });
        toAdd.forEach(function(payload) {
          chain = chain.then(function() {
            return _originalFetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify(payload)
            });
          });
        });
        return chain.then(function() {
          dbg('cart-page: gift changes applied, reloading', { removed: toRemove.length, added: toAdd.length });
          window.location.reload();
        }).catch(function(err) {
          console.error('[EriGift] cart-page enforcer apply failed', err);
          enforcing = false;
        });
      }).catch(function(err) {
        console.error('[EriGift] cart-page enforcer fetch failed', err);
        enforcing = false;
      });
    }

    // Discard any queued ATC events from the section's pre-load interceptor —
    // we don't need them on /cart and they'd grow unbounded otherwise.
    window._eriCartQueue = null;

    // Run on page load
    runOnce();

    // Re-run after any cart-modifying fetch (qty change, remove, update, clear).
    // /cart/add is unlikely on /cart page but we cover it anyway.
    var _origFetch = window.fetch;
    window.fetch = function(url, options) {
      return _origFetch.apply(this, arguments).then(function(response) {
        try {
          var u = typeof url === 'string' ? url : (url && url.url) || '';
          if (response.ok &&
              (u.indexOf('/cart/change') !== -1 ||
               u.indexOf('/cart/update') !== -1 ||
               u.indexOf('/cart/clear') !== -1 ||
               u.indexOf('/cart/add') !== -1)) {
            setTimeout(runOnce, 100);
          }
        } catch (e) { /* never break the original fetch */ }
        return response;
      });
    };
  }

})();
